import { PipeTransform, Pipe } from "@angular/core";
import momentImported from "moment";
const moment = momentImported;

@Pipe({
    name: "wafShortDate",
    standalone: false
})
export class ShortDateStringPipe implements PipeTransform {
  private static readonly ISO8601 = "YYYY-MM-DD";

  transform(value: any, pattern?: string) {
    if (value) {
      return moment(value, ShortDateStringPipe.ISO8601).format(pattern || "L");
    }

    return "";
  }
}
